import React from 'react';
import { Linkedin, Phone, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const LOGO_SRC = 'https://customer-assets.emergentagent.com/job_c7ce965f-b752-41cd-938a-aad5b5cd43c6/artifacts/k82ysdfv_Arogya%20Vitalis%20with%20Tagline.png';
const ADDRESS = '13th Cross, HAL 2nd Stage, Indiranagar, Bengaluru, Karnataka 560008';

const QUICK_LINKS = [
  { id: 'about', label: 'About Us' },
  { id: 'services', label: 'What We Do' },
  { id: 'programs', label: 'Programs' },
  { id: 'testimonials', label: 'Testimonials' },
];

const scrollToSection = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="py-12"
      style={{ background: 'var(--brand-purple-bg)', borderTop: '2px solid var(--brand-periwinkle)' }}
    >
      <div className="container-custom">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <img src={LOGO_SRC} alt="Arogya Vitalis" className="h-12" style={{ filter: 'brightness(0) invert(1)' }} />
            <p className="body-small" style={{ color: 'rgba(253, 251, 249, 0.75)' }}>
              Personalized nutrition for modern lives
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="heading-3" style={{ color: '#FDFBF9' }}>Quick Links</h3>
            <ul className="space-y-3 list-none m-0 p-0">
              {QUICK_LINKS.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="body-small footer-link transition-smooth"
                    data-testid={`footer-link-${link.id}`}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="heading-3" style={{ color: '#FDFBF9' }}>Get In Touch</h3>
            <div className="space-y-3">
              <a
                href={`https://wa.me/${mockData.contact.whatsapp.replace(/\+/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 body-small footer-link transition-smooth"
              >
                <Phone size={16} />
                {mockData.contact.whatsapp}
              </a>
              <a
                href={mockData.contact.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 body-small footer-link transition-smooth"
              >
                <Linkedin size={16} />
                LinkedIn Profile
              </a>
              <div
                className="flex items-start gap-3 body-small"
                style={{ color: 'rgba(253, 251, 249, 0.72)' }}
                data-testid="footer-address"
              >
                <MapPin size={16} className="flex-shrink-0 mt-1" />
                <span>{ADDRESS}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8" style={{ borderTop: '1px solid rgba(253, 251, 249, 0.15)' }}>
          <p className="text-center body-small" style={{ color: 'rgba(253, 251, 249, 0.55)' }}>
            © {currentYear} Arogya Vitalis. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
